<template>
  <div class="mobile-modal">
    <a class="close-modal" @click="emits('close')" href="#">
      <Icon name="general.crossLight" size="base" />
    </a>
    <div v-if="!hideBranding" class="modal-copy" data-testid="sign-up-mobile-modal-branding">
      <p class="modal-title">
        Record a Video,<br />
        Let Zight AI Handle the Rest
      </p>
      <ul>
        <li>✨ Automate documentation</li>
        <li>✨ Skip a meeting</li>
        <li>✨ Save time</li>
      </ul>
    </div>
    <SocialAuth :show-email="true" :redirect-url="props.redirectUrl" @action="onAuth" :in-progress="socialInProgress" />
  </div>
</template>

<script lang="ts" setup>
import SocialAuth from './auth_dialog/Social.vue';
import { Icon } from '@/storybook';
import { useAuth, AuthActions } from '@/composables/useAuth';
import { useAuthModals } from '@/composables/useAuthModals';
import { useBranding } from '@/composables/useBranding';

const props = defineProps<{
  redirectUrl?: string;
}>();

const { onSocialAction, inProgress: socialInProgress } = useAuth(props.redirectUrl);
const emits = defineEmits(['close']);
const { showSignInModal } = useAuthModals();
const { hideBranding } = useBranding();

const onAuth = (action: AuthActions) => {
  if (action === AuthActions.EMAIL) {
    // show normal modal
    emits('close');
    return showSignInModal(props.redirectUrl, true);
  }

  return onSocialAction(action);
};
</script>

<style scoped>
.mobile-modal {
  --outer-gap: 0.625rem;
  position: fixed;
  z-index: 90;
  right: var(--outer-gap);
  bottom: var(--outer-gap);
  left: var(--outer-gap);
  padding: 1rem;
  color: var(--white-copernicus, #fff);
  border-radius: 0.9375rem;
  background: radial-gradient(100% 100% at 50% 0%, #342653 48%, #1c232b 100%), #007aff;
  box-shadow:
    0px -5px 14px 0px rgba(0, 0, 0, 0.2),
    0px 14px 24px 0px rgba(33, 37, 41, 0.1);
}
.mobile-modal :deep(svg) {
  color: var(--white-copernicus, #fff);
}
.modal-copy {
  display: flex;
  flex-direction: column;
  gap: 1.88rem;
}
.modal-copy ul {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.modal-title {
  color: var(--white-copernicus, #fff);
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.close-modal {
  float: right;
  margin: 0 0 1rem 1rem;
  padding: 0.675rem;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.3);
}
</style>
